import { monthlyReportConstants } from '../_constants/monthly-report.constants';

export const fetchMonthlyReportTableStart = () => ({
  type: monthlyReportConstants.FETCH_MONTHLY_REPORT_START
});

export const fetchMonthlyReportSuccess = (data) => ({
  type: monthlyReportConstants.FETCH_MONTHLY_REPORT_SUCCESS,
  payload: data
});

export const fetchMonthlyReportFailure = (errorMessage) => ({
  type: monthlyReportConstants.FETCH_MONTHLY_REPORT_FAILURE,
  payload: errorMessage
});

export const fetchMonthlyReportChartStart = () => ({
  type: monthlyReportConstants.FETCH_MONTHLY_REPORT_CHART_START
});

export const fetchMonthlyReportChartSuccess = (data) => ({
  type: monthlyReportConstants.FETCH_MONTHLY_REPORT_CHART_SUCCESS,
  payload: data
});

export const fetchMonthlyReportChartFailure = (errorMessage) => ({
  type: monthlyReportConstants.FETCH_MONTHLY_REPORT_CHART_FAILURE,
  payload: errorMessage
});

export const setMonthlyReportTableQueries  = (data) => ({
  type: monthlyReportConstants.SET_MONTHLY_REPORT_TABLE_QUERIES,
  payload: data
})

export const setMonthlyReportSharedQueries  = (data) => ({
  type: monthlyReportConstants.SET_MONTHLY_REPORT_SHARED_QUERIES,
  payload: data
})

export const clearMonthluReportResponses = () => ({
  type: monthlyReportConstants.CLEAR_MONTHLY_REPORT_TABLE_RESPONSES
});

export const clearMonthluReportTableQueries  = () => ({
  type: monthlyReportConstants.CLEAR_MONTHLY_REPORT_TABLE_QUERIES
});

export const clearMonthluReportChartQueries  = () => ({
  type: monthlyReportConstants.CLEAR_MONTHLY_REPORT_CHART_QUERIES
});

export const clearMonthluReportSharedQueries  = () => ({
  type: monthlyReportConstants.CLEAR_MONTHLY_REPORT_SHARED_QUERIES
});

export const clearMonthluReportQueries = () => ({
  type: monthlyReportConstants.CLEAR_MONTHLY_REPORT_QUERIES_START
})